import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {AuthService} from "./login.service";
import {ActivatedRoute, Router} from "@angular/router";
import {environment} from "../../../environments/environment";
import {ANALYTICS_ACTION, ANALYTICS_TYPE} from "../../core/interfaces/analytics";
import {SessionQuery} from "../../core/stores/session/session.query";

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Default
})
export class LoginComponent implements OnInit{

  errorString = '';
  loading = false;
  loadingLogin = false;

  get ssoLink(): string {
    return environment.baseUrl + 'auth/saml/login'
  }

  constructor(
    private _authService: AuthService,
    private _router: Router,
    private _sessionQuery: SessionQuery,
  ) {
  }

  ngOnInit() {
    this.checkLogin();
  }

  async checkLogin(): Promise<void> {
    this.loading = true;
    this._authService.loadUserInfo().subscribe({
      next: (success) => {
        this._sessionQuery.sendPendingAnalytics(ANALYTICS_TYPE.ACCESS, ANALYTICS_ACTION.ACCESS);
        this._router.navigate(['/'])
      },
      error: (error) => {this.loading = false; console.error(error)}
    });
  }

  async login(): Promise<void> {
    this._authService.getSamlLogin().subscribe();
  }

}
